// JsFromRoutes CacheKey c039965cc990085b6b19df1a5c3eaeb8
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@js-from-routes/axios'

export default {
  get: definePathHelper('get', '/template_packs/export'),
  create: definePathHelper('post', '/template_packs/export')
}
